<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>

      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="buttonLoading"
                v-bind="attrs"
                v-on="on"
                ><v-icon>cloud_download</v-icon>Export</v-btn
              >
            </template>

            <v-list>
              <v-list-tile @click="exportAllStockLedger()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-tansition"
                offest-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-tansition"
                offest-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                >
                </v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex
              sm3
              v-if="
                user.roleName == 'ADMIN' || user.roleName == 'FINANCE_MANAGER'
              "
            >
              <v-autocomplete
                :items="activeWarehouseList"
                v-model="queryParams.warehouseIds"
                label="Warehouse"
                item-text="name"
                item-value="id"
                menu-props="auto"
                :hide-no-data="true"
                multiple
                autocomplete
                @change="setBin"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                :items="binList"
                v-model="queryParams.binIds"
                label="Bin"
                item-text="name"
                item-value="id"
                menu-props="auto"
                :hide-no-data="true"
                multiple
                autocomplete
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="productCode"
                v-model="queryParams.productCode"
                label="Product Code"
                type="text"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="productName"
                v-model="queryParams.productName"
                label="Product Name"
                type="text"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="activeBrandList"
                v-model="queryParams.brandId"
                label="Brand"
                item-text="name"
                item-value="id"
                :hide-no-data="true"
                menu-props="auto"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="activeCategoryList"
                v-model="queryParams.categoryId"
                label="Category"
                item-text="name"
                item-value="id"
                :hide-no-data="true"
                menu-props="auto"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="activeProductGroupList"
                v-model="queryParams.productGroupId"
                label="Product Group"
                item-text="name"
                item-value="id"
                :hide-no-data="true"
                menu-props="true"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search<v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <!--stock ledger list-->
      <v-flex xs12>
        <v-card>
          <v-data-table
            :must-sort="true"
            :headers="headers"
            :items="stockLedgerList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-btn color="primary" @click="showDetail(props.item)"
                  >Detail</v-btn
                >
              </td>
              <td>
                {{ props.item.ledgerDateInMilliSeconds | formatMsDateTime }}
              </td>
              <td>{{ props.item.warehouseName }}</td>
              <td>{{ props.item.binName }}</td>
              <td>{{ props.item.productName }}</td>
              <td v-if="props.item.productGroupName">
                {{ props.item.productCode }}/{{ props.item.brandName }}/{{
                  props.item.categoryName
                }}/{{ props.item.productGroupName }}
              </td>
              <td v-else>
                {{ props.item.productCode }}/{{ props.item.brandName }}/{{
                  props.item.categoryName
                }}/
              </td>
              <td>{{ props.item.qcNo }}</td>
              <td>{{ props.item.batchNo }}</td>
              <td>
                {{ props.item.expDateInMilliSeconds | formatMsDate }}
              </td>
              <td>
                {{ props.item.mfgDateInMilliSeconds | formatMsDate }}
              </td>
              <td>{{ props.item.openingBalance | decFormat(6) }}</td>
              <td>{{ props.item.stockInQty | decFormat(6) }}</td>
              <td>{{ props.item.stockOutQty | decFormat(6) }}</td>
              <td>{{ props.item.closingBalance | decFormat(6) }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!--stock ledger detail list dialog-->
    <v-dialog
      v-model="showStockLedgerDetailListDialog"
      scrollable
      max-width="1000px"
    >
      <v-card>
        <v-card-title>
          <v-layout wrap>
            <v-flex xs12 sm6 md3>
              <v-select
                :items="referenceTypeList"
                v-model="detailQueryParams.referenceType"
                label="Reference Type"
                item-text="label"
                item-value="value"
                menu-props="auto"
                :hide-no-data="true"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-btn outline color="primary" @click="onSearchDetail">
                Search<v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <v-card>
                <div>
                  <span style="padding-left: 20px; font-weight: bold"
                    >Product Code:
                  </span>
                  <v-chip>
                    <span style="font-weight: bold">{{ productCode }}</span>
                  </v-chip>

                  <span style="padding-left: 20px; font-weight: bold"
                    >Product Name:
                  </span>
                  <v-chip>
                    <span style="font-weight: bold">{{ productName }}</span>
                  </v-chip>

                  <span style="padding-left: 20px; font-weight: bold"
                    >Bin Name:
                  </span>
                  <v-chip>
                    <span style="font-weight: bold">{{ binName }}</span>
                  </v-chip>
                </div>
                <div>
                  <span style="padding-left: 20px; font-weight: bold"
                    >Warehouse Name:
                  </span>
                  <v-chip style="font-weight: bold">
                    <span>{{ warehouseName }}</span>
                  </v-chip>
                  <span style="padding-left: 20px; font-weight: bold"
                    >QC No:
                  </span>
                  <v-chip style="font-weight: bold">
                    <span>{{ qcNo }}</span>
                  </v-chip>
                  <span style="padding-left: 20px; font-weight: bold"
                    >Batch No:
                  </span>
                  <v-chip style="font-weight: bold">
                    <span>{{ batchNo }}</span>
                  </v-chip>

                  <!--<v-btn
                    :loading="detailButtonLoading"
                    color="success"
                    @click="exportAllStockLedgerDetail"
                    >EXPORT ALL</v-btn
                  >-->
                </div>
              </v-card>
            </v-flex>
            <v-flex xs12 class="mt-1">
              <v-card>
                <v-data-table
                  :must-sort="true"
                  :headers="detailHeaders"
                  :items="stockLedgerDetailList"
                  class="elevation-1"
                  :loading="showDetailListLoading"
                  :total-items="detailTotalRows"
                  :rows-per-page-items="rowsPerPageItems"
                  :pagination.sync="detailPagination"
                >
                  <template slot="items" slot-scope="props">
                    <td>
                      {{
                        props.item.ledgerDateInMilliSeconds | formatMsDateTime
                      }}
                    </td>
                    <td>{{ props.item.issueNo }}</td>
                    <td>{{ props.item.referenceType }}</td>
                    <td>{{ props.item.qcNo }}</td>
                    <td>{{ props.item.batchNo }}</td>
                    <td>{{ props.item.description }}</td>
                    <td>{{ props.item.stockInQty | decFormat(6) }}</td>
                    <td>{{ props.item.stockOutQty | decFormat(6) }}</td>
                    <td>{{ props.item.closingBalance | decFormat(6) }}</td>
                    <td>
                      {{ props.item.wacCost | decFormat(6) }}
                    </td>
                    <td>
                      {{ props.item.totalUnitCost | decFormat(6) }}
                    </td>
                    <td>{{ props.item.remark }}</td>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { stockLedgerService } from "../../services/stock-ledger-service";
import { commonService } from "../../services/common-service";
import { warehouseService } from "../../services/warehouse-service";
import { brandService } from "../../services/brand-service";
import { categoryService } from "../../services/category-service";
import { productGroupService } from "../../services/product-group-service";

export default {
  name: "StockLedgerList",
  components: {},
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    showDetailListLoading: false,
    showStockLedgerDetailListDialog: false,
    buttonLoading: false,
    detailButtonLoading: false,
    showFilters: false,
    breadcrumbs: [
      { text: "Warehouse Management", disabled: true },
      { text: "Stock Ledger", disabled: true },
    ],
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      warehouseIds: [],
      binIds: [],
      productCode: "",
      productName: "",
      brandId: "",
      categoryId: "",
      productGroupId: "",
    },
    pagination: {
      descending: false,
      page: 1,
      rowsPerPage: 50,
      sortBy: "w.name",
      totalItems: 0,
    },
    headers: [
      { text: "Action", sortable: false },
      { text: "Date", value: "ledger_date" },
      { text: "Warehouse", align: "left", value: "w.name" },
      { text: "Bin", value: "bi.name" },
      { text: "Product Name", value: "p.name" },
      { text: "Code/Brand/Category/Product Group", sortable: false },
      { text: "QC No", value: "qc_no" },
      { text: "Batch No", value: "batch_no" },
      { text: "Exp Date", value: "exp_date" },
      { text: "Mfg Date", value: "mfg_date" },
      { text: "Opening Balance", sortable: false },
      { text: "Stock In Qty", value: "stockInQty" },
      { text: "Stock Out Qty", value: "stockOutQty" },
      { text: "Closing Balance", sortable: false },
    ],
    detailPagination: {
      descending: false,
      page: 1,
      rowsPerPage: 50,
      sortBy: "ledgerDate",
      totalItems: 0,
    },
    detailQueryParams: {
      fromDate: "",
      toDate: "",
      warehouseId: "",
      binId: "",
      productId: "",
      referenceType: "",
      qcNo: "",
      batchNo: "",
      expDate: "",
      mfgDate: "",
    },
    detailHeaders: [
      { text: "Date", align: "left", value: "ledgerDate" },
      { text: "Issue No", value: "issueNo" },
      { text: "Reference Type", value: "referenceType" },
      { text: "QC No", value: "qcNo" },
      { text: "Batch No", value: "batchNo" },
      { text: "Description", value: "description" },
      { text: "Stock In Qty", value: "stockInQty" },
      { text: "Stock Out Qty", value: "stockOutQty" },
      { text: "Balance", value: "closingBalance" },
      { text: "Unit Cost", value: "wacCost" },
      { text: "Total Unit Cost", value: "totalUnitCost" },
      { text: "Remark", value: "remark" },
    ],
    detailTotalRows: 0,
    totalRows: 0,
    rowsPerPageItems: [25, 50, 100],
    findAll: { id: "", name: "---All---" },
    activeWarehouseList: [],
    binList: [],
    activeBrandList: [],
    activeCategoryList: [],
    activeProductGroupList: [],
    stockLedgerList: [],
    stockLedgerDetailList: [],
    referenceTypeList: [{ label: "---All---", value: "" }],
    productCode: "",
    productName: "",
    binName: "",
    warehouseName: "",
    qcNo: "",
    batchNo: "",
    decimalFormat: "",
  }),
  watch: {
    pagination: {
      handler() {
        this.getStockLedgerList();
      },
      deep: true,
    },
    detailPagination: {
      handler() {
        this.getStockLedgerDetailList();
      },
      deep: true,
    },
  },
  created() {
    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.productCode) {
      this.queryParams.productCode = this.$route.query.productCode;
    }
    if (this.$route.query.productName) {
      this.queryParams.productName = this.$route.query.productName;
    }
    if (this.$route.query.brandId) {
      this.queryParams.brandId = this.$route.query.brandId;
    }
    if (this.$route.query.categoryId) {
      this.queryParams.categoryId = this.$route.query.categoryId;
    }
    if (this.$route.query.productGroupId) {
      this.queryParams.productGroupId = this.$route.query.productGroupId;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.getActiveBrandList();
    this.getActiveCategoryList();
    this.getActiveProductGroupList();
    this.getAllReferenceTypes();
    if (
      this.user.role.roleName == "WAREHOUSE_MANAGER" ||
      this.user.role.roleName == "WAREHOUSE_STAFF" ||
      this.user.role.roleName == "BRANCH_ADMIN"
    ) {
      this.queryParams.warehouseIds.push(this.user.warehouseId);
      if (this.user.role.roleName == "WAREHOUSE_STAFF") {
        this.binList = this.user.selectedBinList;
        this.user.selectedBinList.forEach((v) =>
          this.queryParams.binIds.push(v.id)
        );
      } else {
        this.getActiveWarehouseList().then(() => {
          this.setBin();
        });
      }
    } else if (
      this.user.role.roleName == "PRODUCTION_MANAGER" ||
      this.user.role.roleName == "ASSET_MANAGER"
    ) {
      this.queryParams.warehouseIds.push(this.user.shop.warehouseId);
      this.getActiveWarehouseList().then(() => {
        this.setBin();
      });
    } else {
      this.getActiveWarehouseList();
    }
    this.decimalFormat = commonService.formatdecimal();
  },
  methods: {
    getActiveWarehouseList() {
      return warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then((res) => {
          this.activeWarehouseList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    setBin() {
      //clear bin parameter and bin list in filter
      this.queryParams.binIds = [];
      this.binList = [];
      //add bin lists of selected warehouses
      let warehouseList = this.activeWarehouseList.filter((warehouse) =>
        this.queryParams.warehouseIds.includes(warehouse.id)
      );
      warehouseList.forEach((warehouse) => {
        warehouse.binList.forEach((element) => {
          this.binList.push(element);
        });
      });
    },
    getActiveBrandList() {
      brandService
        .getBrandsByStatus("ACTIVE")
        .then((res) => {
          this.activeBrandList = res.data;
          this.activeBrandList.splice(
            0,
            0,
            JSON.parse(JSON.stringify(this.findAll))
          );
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getActiveCategoryList() {
      categoryService
        .getCategoriesByStatus("ACTIVE")
        .then((res) => {
          this.activeCategoryList = res.data;
          this.activeCategoryList.splice(
            0,
            0,
            JSON.parse(JSON.stringify(this.findAll))
          );
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getActiveProductGroupList() {
      productGroupService
        .getProductGroupsByStatus("ACTIVE")
        .then((res) => {
          this.activeProductGroupList = res.data;
          this.activeProductGroupList.splice(
            0,
            0,
            JSON.parse(JSON.stringify(this.findAll))
          );
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "stock-ledgers",
        query: this.queryParams,
      });
      this.getStockLedgerList();
    },
    getStockLedgerList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      stockLedgerService
        .getStockLedgerList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.stockLedgerList = res.data.warehouseStockLedgerList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    showDetail(stockLedger) {
      this.stockLedgerDetailList = [];
      this.detailQueryParams.expDate = "";
      this.detailQueryParams.mfgDate = "";
      this.productCode = stockLedger.productCode;
      this.productName = stockLedger.productName;
      this.warehouseName = stockLedger.warehouseName;
      this.qcNo = stockLedger.qcNo;
      this.batchNo = stockLedger.batchNo;
      this.binName = stockLedger.binName;
      this.detailQueryParams.fromDate = this.queryParams.fromDate;
      this.detailQueryParams.toDate = this.queryParams.toDate;
      this.detailQueryParams.warehouseId = stockLedger.warehouseId;
      this.detailQueryParams.binId = stockLedger.binId;
      this.detailQueryParams.productId = stockLedger.productId;
      this.detailQueryParams.qcNo = stockLedger.qcNo;
      this.detailQueryParams.batchNo = stockLedger.batchNo;
      if (stockLedger.expDateInMilliSeconds) {
        this.detailQueryParams.expDate = commonService.formatDate(
          new Date(stockLedger.expDateInMilliSeconds),
          "YYYY-MM-DD"
        );
      }
      if (stockLedger.mfgDateInMilliSeconds) {
        this.detailQueryParams.mfgDate = commonService.formatDate(
          new Date(stockLedger.mfgDateInMilliSeconds),
          "YYYY-MM-DD"
        );
      }
      this.detailQueryParams.referenceType = "";
      this.getStockLedgerDetailList().then(
        (this.showStockLedgerDetailListDialog = !this
          .showStockLedgerDetailListDialog)
      );
    },
    getAllReferenceTypes() {
      this.referenceType = [];
      stockLedgerService.getAllStockLedgerReferenceType().then((res) => {
        let tempList = res.data;
        tempList.forEach((temp) => {
          let tempObj = { label: temp, value: temp };
          this.referenceTypeList.push(tempObj);
        });
      });
    },
    getStockLedgerDetailList() {
      this.showDetailListLoading = true;
      let order = this.detailPagination.descending ? "desc" : "asc";
      return stockLedgerService
        .getStockLedgerDetailList(
          this.detailQueryParams,
          this.detailPagination.page,
          this.detailPagination.rowsPerPage,
          this.detailPagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.stockLedgerDetailList = res.data.stockLedgerList;
            this.detailTotalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showDetailListLoading = false;
        });
    },
    onSearchDetail() {
      this.detailQueryParams.page = this.detailPagination.page;
      this.detailQueryParams.size = this.detailPagination.rowsPerPage;
      this.getStockLedgerDetailList();
    },
    /*exportAllStockLedgerDetail() {
      this.detailButtonLoading = true;
      stockLedgerService
        .exportAllStockLedgerDetailExcel(this.detailQueryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.detailButtonLoading = false;
        });
    },*/
    exportAllStockLedger() {
      this.buttonLoading = true;
      stockLedgerService
        .exportAllStockLedgerExcel(this.queryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    },
  },
};
</script>
